import { Form, type FormListFieldData } from 'antd'
import LastUpdateBox from 'components/carePlans/LastUpdateBox'
import { lastUpdateCarerFromUpdatedByData } from 'components/carePlans/lastUpdateCarerFromUpdatedByData'

type AddressFormAddressLastUpdatedProps = {
  field: FormListFieldData
}

/**
 * Shows when this address row was last updated and by whom (any address type).
 */
export function AddressFormAddressLastUpdated({
  field
}: AddressFormAddressLastUpdatedProps) {
  const updatedAt = Form.useWatch(['addresses', field.name, 'updatedAt']) as
    | string
    | undefined
  const updatedByData = Form.useWatch([
    'addresses',
    field.name,
    'updatedByData'
  ]) as { name?: string } | undefined

  const updatedByCarer = lastUpdateCarerFromUpdatedByData(updatedByData)

  if (!updatedAt) {
    return null
  }

  return (
    <LastUpdateBox
      date={updatedAt}
      carer={updatedByCarer}
      noDateText=""
      formInset={{
        outerStyle: { margin: 0, padding: 0 },
        innerStyle: { padding: 0 }
      }}
    />
  )
}
